module.exports = __webpack_public_path__ + "static/img/finished.dd650526.png";